import { HiMagnifyingGlass } from 'react-icons/hi2'

export function Input({ onChange, value, placeholder = '' }) {
	return (
		<div className='border tw-rounded-md tw-flex tw-items-center tw-gap-1 tw-px-2 tw-w-full tw-max-w-[350px] tw-h-[42px]'>
			<HiMagnifyingGlass size={20} className='tw-text-gray-400' />
			<input type='text' placeholder={placeholder} value={value} onChange={onChange} className='tw-full tw-pl-2 border-0' style={{ margin: 0, borderRadius: 0, padding: 0 }} />
		</div>
	)
}
